import { Profile } from "@/integrations/supabase/types/subscription";
import { SubscriptionCard } from "./SubscriptionCard";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { useQueryClient } from "@tanstack/react-query";

interface MembershipSectionProps {
  profile: Profile;
  loading: boolean;
  onSubscribe: (priceId: string) => Promise<void>;
}

export function MembershipSection({ profile, loading, onSubscribe }: MembershipSectionProps) {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const syncSubscription = async () => {
    if (!profile.email) {
      toast({
        title: "Feil",
        description: "Ingen e-post funnet for brukeren",
        variant: "destructive",
      });
      return;
    }

    try {
      const response = await supabase.functions.invoke('sync-stripe-subscription', {
        body: { email: profile.email }
      });

      if (response.error) throw response.error;

      await queryClient.invalidateQueries({ queryKey: ['profile'] });
      
      toast({
        title: "Suksess",
        description: profile.notification_preferences?.is_admin 
          ? "SuperAdmin status bekreftet"
          : "Medlemskapet ditt har blitt synkronisert",
      });

      window.location.reload();
    } catch (error) {
      console.error('Error syncing subscription:', error);
      toast({
        title: "Feil",
        description: "Kunne ikke synkronisere medlemskapet",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="w-full space-y-4 px-0 sm:px-2">
      <SubscriptionCard 
        profile={profile} 
        loading={loading} 
        onSubscribe={onSubscribe}
        onSync={syncSubscription}
      />
    </div>
  );
}